import React from 'react';
import SkeletonTile from "../../SkeletonTile/SkeletonTile";


export const SkeletonLoader = ( { size = 2, tileleftSpace = 18, tileWidth = 250 } ): React.JSX.Element => {
  return (
    <div>
      {Array(size)
        .fill(1)
        .map((data, index) => {
          return (
            <div className="flex-v-center" key={index}>
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={ tileWidth }
                tileRadius={6}
                tileBottomSpace={10}
                tileTopSpace={10}
                tileleftSpace={ tileleftSpace }
              />
            </div>
          );
        })}
    </div>
  );
};